var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app-bar',{staticClass:"white",attrs:{"elevation":"0","dense":""}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }